import type { AbsenceModel } from '@/features/absences/types';

// Mock data for development and testing
export const mockAbsences: AbsenceModel[] = [
  {
    sessionTitle: 'Anglais',
    startDate: '2026-03-04T16:00:00Z',
    endDate: '2026-03-04T18:30:00Z',
    justified: false,
  },
  {
    sessionTitle: 'Tech For Business : Introduction au Webmarketing',
    startDate: '2026-03-03T13:30:00Z',
    endDate: '2026-03-03T16:00:00Z',
    justified: true,
  },
  {
    sessionTitle: 'Statistiques 2',
    startDate: '2026-03-03T07:30:00Z',
    endDate: '2026-03-03T10:00:00Z',
    justified: false,
  },
  {
    sessionTitle: 'Sociologie et Théories des Organisations',
    startDate: '2026-03-02T16:00:00Z',
    endDate: '2026-03-02T18:30:00Z',
    justified: false,
  },
  {
    sessionTitle: 'Tech For Business : Introduction au Webmarketing',
    startDate: '2026-03-02T13:30:00Z',
    endDate: '2026-03-02T16:00:00Z',
    justified: false,
  },
  {
    sessionTitle: 'Commerce International',
    startDate: '2026-03-02T10:00:00Z',
    endDate: '2026-03-02T12:30:00Z',
    justified: true,
  },
  {
    sessionTitle: 'English',
    startDate: '2025-12-03T10:00:00Z',
    endDate: '2025-12-03T12:30:00Z',
    justified: false,
  },
  {
    sessionTitle: 'English',
    startDate: '2025-11-26T13:00:00Z',
    endDate: '2025-11-26T15:30:00Z',
    justified: false,
  },
  {
    sessionTitle: 'Analyse Financière',
    startDate: '2025-11-20T07:30:00Z',
    endDate: '2025-11-20T10:00:00Z',
    justified: false,
  },
  {
    sessionTitle: 'Pensée Critique Et Communication Managériale',
    startDate: '2025-11-14T16:00:00Z',
    endDate: '2025-11-14T18:30:00Z',
    justified: true,
  },
  {
    sessionTitle: 'Pensée Critique Et Communication Managériale',
    startDate: '2025-11-14T10:00:00Z',
    endDate: '2025-11-14T12:30:00Z',
    justified: true,
  },
  {
    sessionTitle: 'Projet Associatif ou Citoyen',
    startDate: '2025-11-13T12:30:00Z',
    endDate: '2025-11-13T17:00:00Z',
    justified: true,
  },
  {
    sessionTitle: 'Introduction à la Fiscalité',
    startDate: '2025-11-13T10:00:00Z',
    endDate: '2025-11-13T12:30:00Z',
    justified: true,
  },
  {
    sessionTitle: 'Analyse Financière',
    startDate: '2025-11-13T07:30:00Z',
    endDate: '2025-11-13T10:00:00Z',
    justified: true,
  },
  {
    sessionTitle: 'English',
    startDate: '2025-11-12T07:30:00Z',
    endDate: '2025-11-12T10:00:00Z',
    justified: true,
  },
];

export class MockAbsencesService {
  static async getAbsences(): Promise<AbsenceModel[]> {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 300));
    return mockAbsences;
  }

  // static async getAbsencesByYear(): Promise<AbsenceModel[]> {
  //   // Simulate API delay
  //   await new Promise((resolve) => setTimeout(resolve, 200));
  //   return mockAbsences;
  // }

  // static async justifyAbsence(
  //   sessionTitle: string,
  //   justification: { reason: string; document?: File }
  // ): Promise<AbsenceModel> {
  //   // Simulate API delay
  //   await new Promise((resolve) => setTimeout(resolve, 500));

  //   // Find the absence and update it
  //   for (const yearData of mockAbsences.absences) {
  //     const absence = yearData.absences.find((a: AbsenceModel) => a.sessionTitle === sessionTitle);
  //     if (absence) {
  //       absence.justified = true;
  //       return absence;
  //     }
  //   }

  //   throw new Error('Absence not found');
  // }

  // static async declareAbsence(absence: {
  //   sessionTitle: string;
  //   startDate: string;
  //   endDate: string;
  //   reason: string;
  // }): Promise<AbsenceModel> {
  //   // Simulate API delay
  //   await new Promise((resolve) => setTimeout(resolve, 400));

  //   const newAbsence: AbsenceModel = {
  //     sessionTitle: absence.sessionTitle,
  //     startDate: absence.startDate,
  //     endDate: absence.endDate,
  //     justified: false,
  //   };

  //   // Add to current year
  //   const currentYear = new Date().getFullYear().toString();
  //   let yearData = mockAbsences.absences.find((a: AbsencesYearModel) => a.year === currentYear);

  //   if (!yearData) {
  //     yearData = { year: currentYear, absences: [] };
  //     mockAbsences.absences.unshift(yearData);
  //   }

  //   yearData.absences.unshift(newAbsence);
  //   return newAbsence;
  // }
}
